module.exports = __webpack_public_path__ + "static/media/dh.34e3a4ad.png";